import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DashCards from '../Common/DashCards';
import Select from "react-select";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import HorizontalChart from '../Charts/HorizontalChart';
import * as Icon from 'react-bootstrap-icons';
import * as XLSX from "xlsx";
import { axiosApi } from '../utils/axiosApi';
import ScatterChart from '../Charts/NewCharts/ScatterChart';
import HorizontalBarChart from '../Charts/NewCharts/HorizontalBarChart';
import AreaChart from '../Charts/NewCharts/AreaChart';
import BarChart from '../Charts/NewCharts/BarChart';
import RaddarChart from '../Charts/NewCharts/RaddarChart';
import StackedVarianceChart from '../Charts/NewCharts/StackedVarianceChart';
import ProjectSlippagePercentageChart from '../Charts/NewCharts/ProjectSlippagePercentageChart';

export const HrAllDashboard = () => {

  const userState = useSelector(state => state.loginData.userData);
  const EmpId = userState?.empId
  const departmentDatas = userState.department.map((itm) => { return itm.label });

  const toggle = [{ name: 'ActualHours', value: 'ActualHours' }, { name: 'EstimatedHours', value: 'EstimateHours' },];

  // ---- FILTER States -----
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // All dashboard graph
  const [dept, setDept] = useState([]);
  const [lead, setLead] = useState("")
  const [empList, SetEmpList] = useState("")
  const [resource, setResource] = useState([]);
  const [depart, setDepart] = useState([]);

  const [isResourceSelected, setIsResourceSelected] = useState(false);

  // state for toggle
  const [selectedRadio, setSelectedRadio] = useState('ActualHours');
  const [slippageImpactDepartment, setSlippageImpactDepartment] = useState([]);

  const [burnoutRiskScatter, setBurnoutRiskScatter] = useState([]);
  const [skillMismatchIndicator, setSkillMismatchIndicator] = useState([]);
  const [systemComplianceDropoff, setSystemComplianceDropoff] = useState([]);
  const [internalMobilityPool, setInternalMobilityPool] = useState([]);
  const [projectLabel, setProjectLabel] = useState([])
  const [projectWiseSlippage, setProjectWiseSlippage] = useState([])
  

  const [resourceLable, setResourceLable] = useState()
  const [resourceWiseActual, setResourceWiseActual] = useState()

  const [departmentLable, setDepartmentLable] = useState()
  const [resourceCount, setResourceCount] = useState()

  const [WeekendResource, setWeekendResource] = useState()
  const [WeekendActual, setWeekendActual] = useState()
  const [bifurcationData, setBifurcationData] = useState()
  const [bifurcationLabel, setBifurcationLabel] = useState()

  // for card api
  const [cardApiRes, setCardApiRes] = useState();

  const downloadExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);

    // Headers
    const data = [[
      'ID',
      'Name',
      'Actual Hours',
      'Estimate Hours',
      'Current Date'
    ]];

    // Current Date
    const currentDate = new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    // Rows
    resourceLable.forEach(item => {
      const row = [
        item._id,
        item.name,
        item.actualHours || 0,
        item.estimateHours || 0,
        currentDate,
      ];

      data.push(row);
    });

    // Add data
    XLSX.utils.sheet_add_aoa(ws, data);

    // Sheet name according to toggle
    const sheetName =
      selectedRadio === 'ActualHours'
        ? 'Actual Hours'
        : 'Estimate Hours';

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      `Resource Wise ${sheetName}`
    );

    // File name
    const excelFileName = `ResourceWise_${sheetName}_${currentDate}.xlsx`;

    XLSX.writeFile(wb, excelFileName);
  };


  // for toggle change graph
  const handleToggleChange = (value) => {
    setSelectedRadio(value);
  };
  const [payload, setPayload] = useState("")

  useEffect(() => {
    const getResouceWiseTimeSpentData = async () => {
      try {
        const payload = {
          empId: EmpId,
          timeType: selectedRadio,
          department: dept?.label !== 'All' ? dept.label : "",
          resource_id: resource.value !== 'All' ? resource.value : "",
          lead: lead?.label !== 'All' ? lead.label : "",
          fromDate: startDate ? startDate : "",
          toDate: endDate ? endDate : "",
        };

        setPayload(payload);

        const res = await axiosApi(process.env.REACT_APP_BASE_URL + "/graph/resourceWiseTimeSpentHR", payload);

        setResourceLable(res?.data?.data);

        const projectsArrayData = res.data.data.map((item) => ({
          type: "bar",
          label: "Resource",
          fill: true,
          data: selectedRadio === "ActualHours" ? item.actualHours : item.estimateHours,
          backgroundColor: "#4E79A7",
        }));
        setResourceWiseActual(projectsArrayData);
      } catch (error) {
        console.log("Error", error);
      }
    };

    getResouceWiseTimeSpentData();
  }, [selectedRadio, dept, resource, lead, startDate, endDate, EmpId]);



  const getDepartmentWiseResourceCount = useCallback(async () => {
    try {
      const payload = {
        "department": dept?.label !== 'All' ? dept.label : "",
        "resource_id": resource.value !== 'All' ? resource.value : "",
        "lead": lead?.label !== 'All' ? lead.label : "",
        // empId: EmpId,
        // fromDate: startDate ? startDate : "",
        // toDate: endDate ? endDate : "",
      };
      await axiosApi(process.env.REACT_APP_BASE_URL + "/graph/departmentWiseResourceCountHR", payload)
        .then((res) => {
          setDepartmentLable(res?.data?.departments)

          let projectsArrayData = [];

          projectsArrayData.push({
            type: "bar",
            label: "Department",
            fill: true,
            data: res?.data?.count,
            backgroundColor: "#4E79A7",
          });
          setResourceCount(projectsArrayData)
        })
        .catch((err) => console.log("Error", err));
    } catch (error) {
      console.log("Error", "Something went wrong...!");
    }
  }, []);

  const getWeekendWorkingHrsTillNowData = useCallback(async () => {
    try {
      const payload = {
        empId: EmpId,
        fromDate: startDate ? startDate : "",
        toDate: endDate ? endDate : "",
        department: dept?.label !== 'All' ? dept.label : "",
        resource_id: resource.value !== 'All' ? resource.value : "",
        lead: lead?.label !== 'All' ? lead.label : "",
      };
      await axiosApi(process.env.REACT_APP_BASE_URL + "/graph/weekendWorkingHrsTillNowHR", payload)
        .then((res) => {
          setWeekendResource(res?.data?.data)

          let projectsArrayData = [];

          projectsArrayData.push({
            type: "bar",
            label: "Resource",
            fill: true,
            data: res?.data?.data,
            backgroundColor: "#4E79A7",
          });
          setWeekendActual(projectsArrayData)
        })
        .catch((err) => console.log("Error", err));
    } catch (error) {
      console.log("Error", "Something went wrong...!");
    }
  }, [EmpId, startDate, endDate, selectedRadio, dept, resource, lead]);

  const getRoleWiseCountData = useCallback(async () => {
    try {
      const payload = {
        empId: EmpId,
        fromDate: startDate ? startDate : "",
        toDate: endDate ? endDate : "",
      };
      await axiosApi(process.env.REACT_APP_BASE_URL + "/graph/bifurcationofResourceTypes", payload, "GET")
        .then((res) => {
          setBifurcationLabel(res?.data?.resourceTypes)

          let projectsArrayData = [];

          projectsArrayData.push({
            type: "bar",
            label: "Resource Type",
            fill: true,
            data: res?.data?.resourceTypeCounts,
            backgroundColor: "#4E79A7",
          });
          setBifurcationData(projectsArrayData)
        })
        .catch((err) => console.log("Error", err));
    } catch (error) {
      console.log("Error", "Something went wrong...!");
    }
  }, []);

  const getSlippageImpactDepartment = () =>
    fetchGraphData({
      endpoint: "/graph/slippageImpactByDepartment",
      setState: setSlippageImpactDepartment,
      defaultValue: [],
    });

  // for cards api
  const totalCardsApis = async () => {
    const payload = {
      empId: lead ? lead.value : EmpId,
      fromDate: startDate ? startDate : "",
      toDate: endDate ? endDate : "",
    };
    await axiosApi(process.env.REACT_APP_BASE_URL + "/HRDashboard/HRDashboardAPI", payload)
      .then((res) => {
        setCardApiRes(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    totalCardsApis()
    getSlippageImpactDepartment();
  }, [startDate, endDate, lead, resource, EmpId])

  // get departmentwise TL
  const [teamLeadList, setTeamLeadList] = useState([]);
  const getTLbyDept = async () => {
    const payload = {
      departmentName: dept ? dept.label : departmentDatas
    };
    await axiosApi(process.env.REACT_APP_BASE_URL + "/department/getDepartmentTL", payload)
      .then((res) => {
        setTeamLeadList(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAllDepartment = async () => {
    try {
      const response = await axiosApi(process.env.REACT_APP_BASE_URL + "/department/getAllDepartment", {}, "GET");
      setDepart(response.data.data); // Update depart state with the array from the response
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const departmentName = [
    { label: "All", value: "All" },
    ...(depart && Array.isArray(depart)
      ? depart.map((itm) => ({
        label: itm.departmentName,
        value: itm.departmentId,
      }))
      : []),
  ];


  const leadName = teamLeadList && Array.isArray(teamLeadList)
    ? teamLeadList.map((itm) => {
      return {
        label: itm.teamLeadName,
        value: itm.teamLeadId,
      };
    })
    : [];

  const getEmpByManagerId = async (e) => {
    const payload = {
      empIdTL: lead ? lead.value : EmpId,
    };
    await axiosApi(process.env.REACT_APP_BASE_URL + "/emp/getParticularTlEmployee", payload)
      .then((res) => {
        SetEmpList(res.data.data)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // for resource list
  const resourceList = empList
    ? empList
      .filter((itm) => itm.empId !== (lead ? lead.value : ''))
      .map((itm) => ({
        label: `${itm.firstName} ${itm.lastName}`,
        value: itm.empId,
      }))
    : [];

  const resourceData = [
    { label: "All", value: "All" },
    ...resourceList,
  ];

  useEffect(() => {
    getAllDepartment()
    // getResouceWiseTimeSpentData(selectedRadio)
  }, [])

  useEffect(() => {
    setResource("")
    getEmpByManagerId()
  }, [lead])

  useEffect(() => {
    setLead("")
    setResource("")
    getTLbyDept()
  }, [dept]);

  useEffect(() => {
    if (userState) {
      getWeekendWorkingHrsTillNowData();
      getDepartmentWiseResourceCount()
      getRoleWiseCountData()
    }
  }, [startDate, endDate, lead, resource, EmpId, dept])


  const handleClear = () => {
    setStartDate("");
    setEndDate("");
    setDept("");
    setLead("");
    setResource("");
    setSelectedRadio("ActualHours");
  };

  const getCommonPayload = (isRiskMatrix = false) => ({
    fromDate: startDate || "",
    toDate: endDate || "",
    department_id: isRiskMatrix ? "" : dept?.value !== "All" ? dept?.value : "",
    subDepartmentId: "",
    resource_id: resource?.value && resource?.value !== "All" ? resource.value : "",
    projectId: "",
    status: "",
    empId: "",
    // EmpId,
  });

  const fetchGraphData = async ({ endpoint, setState, defaultValue = [], isRiskMatrix = false, }) => {
    try {
      const payload = getCommonPayload(isRiskMatrix);
      const res = await axiosApi(`${process.env.REACT_APP_BASE_URL}${endpoint}`, payload);
      setState(res?.data?.data || defaultValue);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getBurnoutRiskScatter();
    getSkillMismatchIndicator();
    getSystemComplianceDropoff();
    getInternalMobilityPool();
    getProjectWiseEstimatedVsActualTimespentData();
    getProjectWiseSlippage();
  }, [startDate, endDate, dept, lead, resource]);

  const getBurnoutRiskScatter = () =>
    fetchGraphData({
      endpoint: "/graph/burnoutRiskScatter",
      setState: setBurnoutRiskScatter,
      defaultValue: [],
    });

  const getSkillMismatchIndicator = () =>
    fetchGraphData({
      endpoint: "/graph/skillMismatchIndicator",
      setState: setSkillMismatchIndicator,
      defaultValue: [],
    });

  const getSystemComplianceDropoff = () =>
    fetchGraphData({
      endpoint: "/graph/systemComplianceDropOff",
      setState: setSystemComplianceDropoff,
      defaultValue: [],
    });

  const getInternalMobilityPool = () => {
    fetchGraphData({
      endpoint: "/graph/internalMobilityPool",
      setState: setInternalMobilityPool,
    });
  };

   const getProjectWiseSlippage = () => 
      fetchGraphData({
        endpoint: "/graph/newprojectWiseSleepage",
        setState: setProjectWiseSlippage,
        defaultValue: null,
      });


  const getProjectWiseEstimatedVsActualTimespentData = () => 
    fetchGraphData({
      endpoint: "/graph/newprojectWiseChartAndTimeTL",
      setState: setProjectLabel,
      defaultValue: null,
    });

  return (
    <div className='EmpDash' data-aos='fade-up'>
      <Container>
        <Row className='justify-content-between w-100 mt-2'>
          <Col className='mb-4 mb-md-0'>
            <Form.Group>
              <Form.Label> Department </Form.Label>
              <Select
                //  className="custom-select"
                isMulti={false}
                isSearchable={true}
                value={dept}
                options={departmentName}
                // onChange={(selectedOption)=>{setDept(selectedOption);setLead("");setResource("")}}
                onChange={(selectedOption) => {
                  if (selectedOption && selectedOption.value === "All") {
                    setDept(selectedOption);
                    setLead("");
                    setResource([]);
                    setPayload((prevPayload) => ({ ...prevPayload, department: "", lead: "", resource_id: "" }));
                    totalCardsApis();
                  }
                  else {
                    setDept(selectedOption);
                    setPayload((prevPayload) => ({ ...prevPayload, department: selectedOption.label }));
                    setLead("");
                    setResource("");
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col className='mb-4 mb-md-0'>
            <Form.Group>
              <Form.Label> Lead/Manager </Form.Label>
              <Select
                // className="custom-select"
                isMulti={false}
                isSearchable={true}
                value={lead}
                options={leadName}
                onChange={(selectedOption) => { setPayload((prevPayload) => ({ ...prevPayload, lead: selectedOption.label })); setLead(selectedOption); setResource("") }}
              // onChange={(selectedOption) => { setLead(selectedOption); setResource("") }}
              />
            </Form.Group>
          </Col>
          <Col className='mb-4 mb-md-0'>
            <Form.Group>
              <Form.Label>Resource</Form.Label>
              <Select
                // className="custom-select"
                isMulti={false}
                isSearchable={true}
                value={resource}
                // options={lead ? resourceList : []}
                options={userState?.resourceType === "teamlead" ? resourceData : lead ? resourceData : []}
                // onChange={(selectedOption) => setResource(selectedOption)}
                onChange={(selectedOption) => {
                  if (selectedOption && selectedOption.value === "All") {
                    setResource(selectedOption);
                    setIsResourceSelected(!!selectedOption);
                    setPayload((prevPayload) => ({ ...prevPayload, resource_id: selectedOption.value !== "All" ? selectedOption.value : " " }));
                    totalCardsApis();
                  }
                  else {
                    setResource(selectedOption);
                    setIsResourceSelected(!!selectedOption);
                    setPayload((prevPayload) => ({ ...prevPayload, resource_id: selectedOption.value !== "All" ? selectedOption.value : " " }));
                    totalCardsApis();
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col md={5} className='d-flex justify-content-end mt-0 mt-md-0'>
            <Row className='w-100 align-items-end'>

              {/* From Date */}
              <Col md={4} className='ps-0 mb-2 mb-md-0'>
                <Form.Group>
                  <Form.Label>From</Form.Label>

                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value)
                      setEndDate("")
                    }}
                  />
                </Form.Group>
              </Col>

              {/* To Date */}
              <Col md={4} className='ps-0 mb-2 mb-md-0'>
                <Form.Group>
                  <Form.Label>To</Form.Label>

                  <Form.Control
                    type="date"
                    value={endDate}
                    min={startDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>

              {/* Clear Button */}
              <Col md={4} className='ps-0'>
                <Button
                  className='clearBtn w-100'
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Col>

            </Row>
          </Col>
        </Row>

        <DashCards totalResource={cardApiRes ? cardApiRes?.totalResources : 0}
          totalProj={cardApiRes ? cardApiRes?.totalProjects : 0} />

        <div className="analyticsWrapper">
          <div className="analyticsHeader">
            <h3>Analytics</h3>
            <p>Charts & Visualizations</p>
          </div>

          <div className="dashboardGraphs">
                      <Row className="g-4">
                        {/* Project Efficiency */}
                        <Col sm={12}>
                          <StackedVarianceChart
                            xAxisTitle='Hours'
                            yAxisTitle='Projects'
                            label="project"
                            value1="estimatedHrs"    // Total Estimated Hours
                            value2="actualHrs"      // Actual Hours Spent
                            chartData={projectLabel}
                            chartHeight="450px"
                            chartHeading="Project Efficiency: Estimated vs. Actual Time Variance (Hrs)"
                          />
                        </Col>

                        {/* Project wise Slippage */}
                        <Col sm={12}>
                          <ProjectSlippagePercentageChart
                            yAxisTitle='Slippage (%)'
                            xAxisTitle='Projects'
                            label="project"
                            slippageKey="slippagePct"
                            chartData={projectWiseSlippage}
                            chartHeight="650px"
                            chartHeading="Projects Health: Average Slippage (%)"
                          />
                        </Col>
                      </Row>
                    </div>

          <div className="dashboardGraphs">
            <Row className="g-4">
              {/* {burnoutRiskScatter.length > 0 && ( */}
              <Col lg={12} md={12} sm={12}>
                <div className="graphCard">
                  <ScatterChart
                    chartLabel="Employee Workload vs Productivity"
                    chartData={burnoutRiskScatter}
                    purpose="Tracks extreme workloads vs declining output"
                    xField="totalActualHrs"
                    yField="efficiency"
                    colorField="riskLevel"
                    xAxisTitle="Total Actual Hours"
                    yAxisTitle="Efficiency"
                    fieldsLabel="totalActualHrs vs efficiency by resourceName"
                    yAxisMin={0}
                    yAxisMax={4}
                    yAxisInterval={1}
                    yAxisFormatter={(value) => {
                      switch (value) {
                        case 1:
                          return "Low";
                        case 2:
                          return "Medium";
                        case 3:
                          return "High";
                        default:
                          return "";
                      }
                    }}
                    tooltipFields={[
                      {
                        key: "resourceName",
                        label: "Resource",
                      },
                      {
                        key: "riskLevel",
                        label: "Risk Level",
                      },
                      {
                        key: "totalTasks",
                        label: "Total Tasks",
                      },
                    ]}
                  />
                </div>
              </Col>
              {/* )} */}

              {/* {skillMismatchIndicator.length > 0 && ( */}
              {/* <Col lg={12} md={12} sm={12}>
                <div className="graphCard">
                  <HorizontalBarChart
                    chartLabel="Employees Needing Support"
                    chartData={skillMismatchIndicator}
                    fieldsLabel="Highest reopenCount & isRejected:true by empId"
                    xField="mismatchScore"
                    yField="resourceName"
                    barColor="#7C4DFF"
                    purpose="Identifies employees struggling with core tasks."
                    legendLabel="Task Name"
                    tooltipFields={[
                      { key: "resourceName", label: "Resource" },
                      { key: "empId", label: "Employee ID" },
                      { key: "reopenCount", label: "Reopen Count" },
                      { key: "rejectedTasks", label: "Rejected Tasks" },
                      { key: "mismatchScore", label: "Mismatch Score" },
                      { key: "totalTasks", label: "Total Tasks" },
                    ]}
                  />
                </div>
              </Col> */}
              {/* )} */}

              {/* {systemComplianceDropoff.length > 0 && ( */}
              <Col lg={12} md={12} sm={12}>
                <div className="graphCard">
                  <AreaChart
                    chartLabel="Task Update Compliance"
                    chartData={systemComplianceDropoff}
                    fieldsLabel="Count of tasks missing actualHours or statuses"
                    purpose="Tracks if employees are giving up on using internal tools."
                    legendLabel="Compliance Drop"
                    xField="date"
                    yField="totalComplianceDrop"
                    xAxisTitle='Date'
                    yAxisTitle='Compliance'
                    tooltipFields={[
                      {
                        key: "missingActualHours",
                        label: "Missing Actual Hours",
                      },
                      // {
                      //   key: "pendingStatus",
                      //   label: "Pending Status",
                      // },
                      {
                        key: "pendingStatus",
                        label: "Compliance Drop",
                      },
                      {
                        key: "totalTasks",
                        label: "Total Tasks",
                      },
                    ]}
                  />
                </div>
              </Col>
              {/* )} */}

               {/* {slippageImpactDepartment?.length > 0 && ( */}
              <Col lg={12} md={12} sm={12}>
                <div className="graphCard">
                  <RaddarChart
                    chartData={slippageImpactDepartment}
                    chartLabel="Slippage Impact by Department"
                    fieldsLabel=""
                    purpose="Identifies which department is consistently missing deadlines."
                    legendLabel="Average Slippage"
                  />
                </div>
              </Col>
            {/* )} */}

              {/* {internalMobilityPool.length > 0 && ( */}
              <Col lg={6} md={6} sm={12}>
                <div className="graphCard">
                  <BarChart
                    chartLabel="Top Performing Employees"
                    chartData={internalMobilityPool}
                    xField="resourceName"
                    yField="efficiency"
                    yAxisTitle="Efficiency"
                    xAxisTitle='Employees'
                    rotateLabel={0}
                    barColor="#3B82F6"
                    purpose="Identifies weekend work and 'always-on' behavior."
                    seriesLabel="Efficiency"
                    tooltipFields={[
                      {
                        key: "resourceName",
                        label: "Resource",
                      },
                      {
                        key: "empId",
                        label: "Employee ID",
                      },
                      {
                        key: "efficiency",
                        label: "Efficiency",
                      },
                      {
                        key: "totalTasks",
                        label: "Total Tasks",
                      },
                      {
                        key: "totalActualHours",
                        label: "Actual Hours",
                      },
                      // {
                      //   key: "sameDayRatio",
                      //   label: "Same Day Ratio",
                      // },
                      // {
                      //   key: "sameDayEntryRatio",
                      //   label: "Same Day Entry Ratio",
                      // },
                    ]}
                  />
                </div>
              </Col>
              {/* )} */}
             
            </Row>
          </div>
        </div>
      </Container>
    </div >
  )
}

